import React, { useContext } from "react";
import { ShopContext } from "./Context";
const Product = (props) => {
  const { id, productName, price, productImage, category, colour } = props.item;
  const { addToCart, cartItems } = useContext(ShopContext);
  const cartItemAmount = cartItems[id];

  const items = props.item;

  return (
    <div className="main-container grid grid-cols-3 gap-y-[4rem] py-9 place-items-center">
      {items.map((product) => (
    
        <div className="main-container grid grid-cols-1 gap-y-[4rem] py-2 place-items-center">
          <div>
            <div className="container bg-slate-200  w-[18rem] h-[25rem]  rounded-3xl   shadow-xl hover:scale-95">
              <img
                src={product.productImage}
                className="mx-10 rounded-3xl py-2 w-[13rem] h-[16rem]"
              />
              <p className="ml-[2rem] text-xl font-serif  leading-tight ">
                {product.productName}
              </p>
              <p className="ml-[2rem] text-xl font-serif ">${product.price}</p>
              <button
                className="w-[14rem] bg-black text-white h-[2.5rem] rounded-lg mx-[1.5rem] mt-2"
                onClick={() => addToCart(product.id)}
              >
                ADD TO CART {cartItemAmount > 0 && <> ({cartItemAmount})</>}
              </button>
            </div>
          </div>
        </div>
     ))}
    </div>
  );
};

export default Product;
